const NOTEBOOK_PATH =
  "M25.4545 8H11.5455C10.6919 8 10 8.59695 10 9.33333V26.6667C10 27.403 10.6919 28 11.5455 28H25.4545C26.3081 28 27 27.403 27 26.6667V9.33333C27 8.59695 26.3081 8 25.4545 8Z";
const RING_LINES_PATH = "M8 12.1333H12.56M8 18H12.56M8 23.8667H12.56";
const TEXT_LINES_PATH =
  "M15.5996 13.6001H23.1996M15.5996 18.0001H23.1996M15.5996 22.4001H20.1596";

/**
 * Design Scope glyph — ruled notebook, no tile. Drawn with lines, so the
 * colour comes from a `stroke-*` class in `className` (use `stroke-current`
 * to follow the surrounding text colour).
 */
export default function DesignScopeCiqIcon({
  size = 12,
  className = "stroke-black",
  opacity = "0.6"
}: {
  size?: number;
  className?: string;
  opacity?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="6.5 6 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity={opacity}
      >
        <path d={NOTEBOOK_PATH} />
        <path d={RING_LINES_PATH} />
        <path d={TEXT_LINES_PATH} />
      </g>
    </svg>
  );
}

/**
 * Design Scope badge — the same glyph on its fixed-colour tile.
 * Design: 36×36 container (#337CD7) + glyph (#ABCFE2). Used by CiqIconBox.
 */
export function DesignScopeTileCiqIcon({
  size = 36,
  className = ""
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="36" height="36" rx="4" fill="#337CD7" />
      <g
        stroke="#ABCFE2"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Filled with the tile colour so the ring ticks read as passing behind the cover. */}
        <path d={NOTEBOOK_PATH} fill="#337CD7" />
        <path d={RING_LINES_PATH} />
        <path d={TEXT_LINES_PATH} />
      </g>
    </svg>
  );
}
